





















import { defineComponent, ref, useAsync } from "@nuxtjs/composition-api";
import SvgImage from "~/components/General/SvgImage.vue";
import useStoryblok from "~/composables/useStoryblok";

export default defineComponent({
  components: {
    SvgImage,
  },
  props: {
    showFoltersNoProducst: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { getStoryblokData } = useStoryblok();
    const storyblokData = ref(null);

    useAsync(async () => {
      await getStoryblokData("coming-soon-template").then((res) => {
        storyblokData.value = res?.story?.content;
      });
    });

    return {
      storyblokData,
    };
  },
});
